import { makeVar } from "@apollo/client";
const url = new URL(window.location);
const templateId = url.searchParams.get("template_id");
const templateVar = makeVar({ templateId });
export default templateVar;
